import React from 'react';
import { states } from '@/constants/lifecycle';
import IconButton from '@/components/buttons/IconButton';

const DatasetSubscribeButton = ({ onClick, saveStatus, subscribed }) => (
  <IconButton
    className="aridhia-dataset-subscribe-button ml-10 whitespace-nowrap"
    disabled={saveStatus === states.PENDING || subscribed}
    icon
    iconName="eye"
    floated="right"
    labelPosition="left"
    messageId={subscribed ? 'subscriptions.subscribed' : 'subscriptions.subscribe'}
    onClick={onClick}
    primary
  />
);

export default DatasetSubscribeButton;
